import React,
{
    useState
}
from "react";
import AssessmentQuestion
    from "../../administration/giraffe/components/AssessmentQuestion";
	
import AssetInfoCard
    from "./AssetInfoCard";
		
import AssetLocationCard
	    from "./AssetLocationCard";
		
import AssetDigitalTwinCard
	    from "./AssetDigitalTwinCard";
		
import AssetPhotosCard
	    from "./AssetPhotosCard";

export default function AssetRegisterRow()
{
	
	const [condition, setCondition] = useState("Good");
	const [compliance, setCompliance] = useState("Pass");
	const [criticality, setCriticality] = useState("Medium");
	
	const [advancedOpen, setAdvancedOpen] =
	    useState(false);

	const conditionOptions =
	[
	    {
	        label: "Excellent",
	        gradient: "linear-gradient(180deg,#2fa56f 0%,#15803d 100%)"
	    },
	    {
	        label: "Good",
	        gradient: "linear-gradient(180deg,#5fbf4a 0%,#4d9f34 100%)"
	    },
	    {
	        label: "Fair",
	        gradient: "linear-gradient(180deg,#e6a21a 0%,#b45309 100%)"
	    },
	    {
	        label: "Poor",
	        gradient: "linear-gradient(180deg,#e05252 0%,#b91c1c 100%)"
	    },
	    {
	        label: "Critical",
	        gradient: "linear-gradient(180deg,#8b1e1e 0%,#5c1010 100%)"
	    }
	];

	const complianceOptions =
	[
	    {
	        label: "Pass",
	        gradient: "linear-gradient(180deg,#2fa56f 0%,#15803d 100%)"
	    },
	    {
	        label: "Advisory",
	        gradient: "linear-gradient(180deg,#e6a21a 0%,#b45309 100%)"
	    },
	    {
	        label: "Fail",
	        gradient: "linear-gradient(180deg,#e05252 0%,#b91c1c 100%)"
	    },
	    {
	        label: "N/A",
	        gradient: "linear-gradient(180deg,#9ca3af 0%,#6b7280 100%)"
	    }
	];
	
	
	const criticalityOptions =
	[
	    {
	        label: "Low",
	        gradient: "linear-gradient(180deg,#2fa56f 0%,#15803d 100%)"
	    },
	    {
	        label: "Medium",
	        gradient: "linear-gradient(180deg,#e6a21a 0%,#b45309 100%)"
	    },
	    {
	        label: "High",
	        gradient: "linear-gradient(180deg,#e05252 0%,#b91c1c 100%)"
	    },
	    {
	        label: "Mission Critical",
	        gradient: "linear-gradient(180deg,#8b1e1e 0%,#5c1010 100%)"
	    }
	];
	
    const inputStyle =
    {
        width: "100%",
        padding: "12px 14px",
        borderRadius: "10px",
        border: "1px solid #d9e1eb",
        background: "#fbfcfe",
        fontSize: "14px",
        outline: "none",
        boxSizing: "border-box"
    };

    const labelStyle =
    {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#666",
        textTransform: "uppercase",
        letterSpacing: ".8px",
        marginBottom: "6px"
    };

    const pillStyle =
    {
        width: "100%",
        padding: "12px",
        borderRadius: "10px",
        border: "none",
        fontWeight: "bold",
        cursor: "pointer",
        fontSize: "14px"
    };

    return (

        <div
            style={{
                background: "#fff",
                border: "1px solid #dfe6ef",
                borderRadius: "14px",
                marginBottom: "22px",
                padding: "24px",
				boxShadow:
				advancedOpen
				?
				"0 18px 40px rgba(0,0,0,.18)":
				"0 8px 24px rgba(0,0,0,.08)",
                transition: "all .2s ease"
            }}
        >

            {/* ========================================================= */}
            {/* Header                                                    */}
            {/* ========================================================= */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start"
                }}
            >

                <div
                    style={{
                        display: "flex",
                        gap: "16px"
                    }}
                >

                    <input
                        type="checkbox"
                        defaultChecked
                        style={{
                            transform: "scale(1.35)",
                            marginTop: "8px"
                        }}
                    />

                    <div>

                        <div
                            style={{
                                fontSize: "28px",
                                fontWeight: "bold",
                                color: "#222"
                            }}
                        >
                            Suspended Cable Tray
                        </div>

                        <div
                            style={{
                                marginTop: "8px",
                                display: "inline-block",
                                background: "#eef6ff",
                                color: "#5a9bd6",
                                borderRadius: "999px",
                                padding: "5px 14px",
                                fontSize: "12px",
                                fontWeight: "bold"
                            }}
                        >
                            🤖 AI Generated Description
                        </div>

                    </div>

                </div>

                <div
                    style={{
                        textAlign: "right"
                    }}
                >

                    <div
                        style={{
                            background: "#e8f8ed",
                            color: "#2e7d32",
                            padding: "7px 16px",
                            borderRadius: "999px",
                            fontWeight: "bold",
                            display: "inline-block"
                        }}
                    >
                        High Confidence
                    </div>

                    <div
                        style={{
                            marginTop: "10px",
                            fontSize: "34px",
                            fontWeight: "bold",
                            color: "#5a9bd6"
                        }}
                    >
                        92%
                    </div>

                </div>

            </div>

            {/* ========================================================= */}
            {/* Observation                                               */}
            {/* ========================================================= */}

            <div
                style={{
                    marginTop: "24px",
                    background: "#f7f9fc",
                    border: "1px solid #e2e8ef",
                    borderRadius: "12px",
                    padding: "18px"
                }}
            >

                <div
                    style={{
                        fontWeight: "bold",
                        color: "#555",
                        marginBottom: "10px"
                    }}
                >
                    🤖 AI Observation
                </div>

                <div
                    style={{
                        color: "#666",
                        lineHeight: "1.8"
                    }}
                >
                    Perforated galvanised cable tray suspended at high level.
                    Appears securely fixed with no visible corrosion,
                    distortion or missing supports.
                </div>

            </div>

			{/* ========================================================= */}
			{/* Editable Fields                                           */}
			{/* ========================================================= */}

			<div
			    style={{
			        display: "grid",
			        gridTemplateColumns: "repeat(3, 1fr)",
			        gap: "20px",
			        marginTop: "28px"
			    }}
			>

			    <div>

			        <div style={labelStyle}>
			            🏷 Asset Code
			        </div>

			        <input
			            style={inputStyle}
			            placeholder="AI Generated"
			        />

			    </div>

			    <div>

			        <div style={labelStyle}>
			            🏢 Asset Type
			        </div>

			        <select style={inputStyle}>
			            <option>Mechanical</option>
			            <option>Electrical</option>
			            <option>Fire</option>
			            <option>Furniture</option>
			            <option>Building Fabric</option>
			        </select>

			    </div>

			    <div>

			        <div style={labelStyle}>
			            🗂 Asset Class
			        </div>

			        <select style={inputStyle}>
			            <option>Maintainable Asset</option>
			            <option>Building Asset</option>
			            <option>IT Asset</option>
			            <option>FF&E</option>
			        </select>

			    </div>

			    <div>

			        <div style={labelStyle}>
			            📂 Category
			        </div>

			        <select style={inputStyle}>
			            <option>Cable Tray</option>
			        </select>

			    </div>

			    <div>

			        <div style={labelStyle}>
			            🏭 Manufacturer
			        </div>

			        <input
			            style={inputStyle}
			            placeholder="AI Suggestion"
			        />

			    </div>

			    <div>

			        <div style={labelStyle}>
			            📦 Model
			        </div>

			        <input
			            style={inputStyle}
			            placeholder="Model Number"
			        />

			    </div>

			</div>

			<div
			    style={{
			        marginTop: "28px"
			    }}
			>

			    <AssessmentQuestion
			        title="Condition"
			        value={condition}
			        options={conditionOptions}
			        setValue={setCondition}
			    />

			    <AssessmentQuestion
			        title="Compliance"
			        value={compliance}
			        options={complianceOptions}
			        setValue={setCompliance}
			    />
				
				<AssessmentQuestion
				    title="Criticality"
				    value={criticality}
				    options={criticalityOptions}
				    setValue={setCriticality}
				/>

			</div>

            {/* ========================================================= */}
            {/* Footer                                                    */}
            {/* ========================================================= */}

            <div
                style={{
                    marginTop: "30px",
                    borderTop: "1px solid #e7edf4",
                    paddingTop: "18px",
					paddingBottom: "18px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >

                <div
                    style={{
                        color: "#777",
                        fontSize: "13px"
                    }}
                >
                    ✨ AI has pre-populated the recommended values.
                </div>

				<button
				    onClick={() => setAdvancedOpen(!advancedOpen)}
				    style={{
				        background: "none",
				        border: "none",
				        color: "#5a9bd6",
				        cursor: "pointer",
				        fontWeight: "bold",
				        fontSize: "14px"
				    }}
				>
				    {advancedOpen ? "▲" : "▼"} Advanced Asset Information
				</button>

            </div>
			<div
			    style={{
			        maxHeight: advancedOpen ? "4500px" : "0px",
			        overflow: "hidden",
			        transition: "all .35s ease",
			        background: "#ffffff",
			        borderRadius: advancedOpen
			            ? "0 0 14px 14px"
			            : "0px",
			        boxShadow: advancedOpen
			            ? "inset 0 10px 18px rgba(0,0,0,.08)"
			            : "none"
			    }}
			>

			    <div
			        style={{
			            padding: advancedOpen ? "28px" : "0px 28px"
			        }}
			    >

				<div
				    style={{
				        display: "flex",
				        alignItems: "flex-start",
				        gap: "24px",
				        width: "100%",
				        minHeight: "200px"
				    }}
				>

				    <div
				        style={{
				            flex: 1,
				            display: "flex",
				            flexDirection: "column",
				            gap: "20px"
				        }}
				    >
						<AssetInfoCard
						    title="Asset Details"
						    fields={[
						        {label:"Manufacturer", type:"text"},
						        {label:"Model", type:"text"},
						        {label:"Serial Number", type:"text"},
						        {label:"Install Date", type:"date"},
						        {label:"Warranty Expiry", type:"date"}
						    ]}
						/>

						<AssetInfoCard
						    title="Compliance"
						    fields={[
						        {label:"Fire Rating", type:"select"},
						        {label:"PAT Required", type:"checkbox"},
						        {label:"LOLER", type:"checkbox"},
						        {label:"PUWER", type:"checkbox"}
						    ]}
						/>

						<AssetInfoCard
						    title="Lifecycle"
						    fields={[
						        {label:"Expected Life", type:"number"},
						        {label:"Replacement Cost", type:"currency"},
						        {label:"Residual Value", type:"currency"}
						    ]}
						/>
						</div>
						<div
						       style={{
						           flex: 1,
						           display: "flex",
						           flexDirection: "column",
								   gap: "20px"
						       }}
						   >
						<AssetLocationCard/>
						<AssetDigitalTwinCard/>	
						<AssetPhotosCard/>			
						</div>
					</div>

			    </div>

			</div>
        </div>

    );
}